<template>
  <component :is="tag" class="icon-with-text">
    <a-icon
      v-bind="{
        [icon ? 'type' : 'component']: icon || component
      }"
      class="icon-with-text__icon"
    />
    <div class="icon-with-text__content">
      <slot />
    </div>
  </component>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    component: {
      type: Object,
      default: null
    },
    tag: {
      type: String,
      default: 'div'
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-with-text {
  display: flex;
  flex-wrap: wrap;

  &:not(:last-child) {
    margin-bottom: 10px;
  }

  &__content {
    line-height: 32px;
  }

  &__icon {
    width: 32px;
    height: 32px;
    background-color: rgba(black, 0.05);
    font-size: 16px;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
  }

  ::v-deep a {
    color: inherit;
    font: inherit;
  }
}
</style>
